<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="header-left">
      <h2>Messages</h2>
      <mat-button-toggle-group [value]="activeMailbox" (change)="onMailboxChange($event.value)" hideSingleSelectionIndicator>
        <mat-button-toggle value="inbox">Inbox</mat-button-toggle>
        <mat-button-toggle value="sent">Sent</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="button-group">
      @if (activeMailbox === 'inbox') {
        <button mat-stroked-button (click)="onMarkAllAsRead()">
          <mat-icon>mark_email_read</mat-icon>
          Mark all as read
        </button>
      }
      <button mat-raised-button color="primary" (click)="onComposeMessage()">
        <mat-icon>edit</mat-icon>
        Compose
      </button>
    </div>
  </div>

  @if (dataSource.data.length > 0) {
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" class="mat-elevation-z2">

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
        <td mat-cell *matCellDef="let message" [class.unread]="!message.isRead && activeMailbox === 'inbox'">
          @if (activeMailbox === 'sent') {
            <mat-icon class="mail-icon">send</mat-icon>
          } @else if (message.isAnswer) {
            <mat-icon class="reply-icon">reply</mat-icon>
          } @else {
            <mat-icon class="mail-icon">{{ message.isRead ? 'drafts' : 'mark_email_unread' }}</mat-icon>
          }
          @if (message.title) { {{ message.title }} } @else { <em>(Untitled)</em> }
        </td>
      </ng-container>

      <ng-container matColumnDef="sentByUserFullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
        <td mat-cell *matCellDef="let message" [class.unread]="!message.isRead && activeMailbox === 'inbox'">{{ message.sentByUserFullName }}</td>
      </ng-container>

      <ng-container matColumnDef="recipients">
        <th mat-header-cell *matHeaderCellDef>To</th>
        <td mat-cell *matCellDef="let message">{{ getRecipientNames(message) }}</td>
      </ng-container>

      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef>Company</th>
        <td mat-cell *matCellDef="let message">
          @if (message.companyId) {
            <span class="name-cell">
              <a [routerLink]="['/companies/edit', message.companyId]" class="company-link-btn" title="Edit company" (click)="$event.stopPropagation()">
                <mat-icon>open_in_new</mat-icon>
              </a>
              {{ message.companyName }}
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let message" [class.unread]="!message.isRead && activeMailbox === 'inbox'">{{ message.createdDate | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let message" class="actions-cell">
          <div class="action-buttons">
            <button mat-icon-button
                    class="attachment-button"
                    [class.has-attachment]="message.hasAttachment"
                    [matTooltip]="message.hasAttachment ? 'Has attachment' : ''"
                    [disabled]="!message.hasAttachment">
              <mat-icon>attach_file</mat-icon>
            </button>
            @if (activeMailbox === 'inbox') {
              <button mat-icon-button
                      class="read-button"
                      [matTooltip]="message.isRead ? 'Mark as unread' : 'Mark as read'"
                      (click)="onToggleReadStatus(message, $event)">
                <mat-icon>{{ message.isRead ? 'drafts' : 'mark_email_unread' }}</mat-icon>
              </button>
            }
            @if (!message.isAnswer) {
              <button mat-icon-button
                      class="delete-button"
                      matTooltip="Delete"
                      (click)="onDeleteClick(message, $event)">
                <mat-icon>delete</mat-icon>
              </button>
            } @else {
              <span class="icon-placeholder"></span>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-row" (click)="onRowClick(row)"></tr>
    </table>
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 20, 50]"
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)">
    </mat-paginator>
  } @else {
    <div class="empty-state">
      No messages found.
    </div>
  }
</div>
